<template>
    <div class="col-12">
        <div
            class="trip-results"
            style="height: 50vh !important;"
        >
            <map-container
                ref="mapContainer"
                :find-user="false"
                :center="mapCenter"
                @onMapClicked="mapClicked"
                @onMapChanged="mapChanged"
            />
            <trip-map
                v-if="map"
                ref="tripMap"
                :trip-results="trips"
                :trip-item="mapItem"
                :map="map"
                :show-trip-info="false"
                :area-group="areaGroup"
                @setCurrentPoint="setCurrentPoint"
                @carPositionSimulating="setCarPositionSimulating"
            />
        </div>
        <div class="map-trip-details-table pl-1 pt-1 pr-1">
            <b-table
                show-empty
                small
                selectable
                ref="selectableTable"
                :select-mode="selectMode"
                selected-variant="success"
                striped hover
                :items="tableItems"
                :fields="fields"
                @row-selected="showTripOnMap"
            >
                <template v-slot:cell(date)="row">
                    {{ getShortDateString(row.value) }}
                </template>
                <template v-slot:cell(tripnote)="row">
                    <span v-if="row.item.tripnotes && row.item.tripnotes.length > 0">
                        <b-tooltip :target="'notes'+row.item.id" triggers="hover" placement="left">
                            <span
                                v-for="tripNote in row.item.tripnotes"
                                v-bind:key="tripNote.id">
                                <span class="tooltip-title">{{ toLocalTime(tripNote.start_time) }}-{{ toLocalTime(tripNote.end_time) }}</span>
                                {{ tripNote.note }}
                            </span>
                        </b-tooltip>
                        <font-awesome-icon
                            :id="'notes'+row.item.id"
                            icon="comment"
                            class="note"
                        />
                    </span>
                </template>
            </b-table>
        </div>
        <b-row class="nopads">
            <div class="col-md-6 nopads">
                <div v-if="mapItem" class="button-container" style="text-align: left">
                    <b-button
                        class="result-button"
                        style="min-width: 7em"
                        variant="primary"
                        :disabled="allTrips === true"
                        @click="showAllTrips"
                    >
                        {{ $t('common.show_all') }}
                    </b-button>
                    <b-button
                        class="result-button"
                        style="min-width: 7em"
                        variant="success"
                        :disabled="mapItem == null || this.withGeom === false"
                        @click="simulateTrip"
                    >
                        {{ $t('trip.simulate_trip') }}
                    </b-button>
                </div>
            </div>
        </b-row>
        <div
            v-if="loading > 0"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import MapContainer from "../map/MapContainer";
import TripMap from '../trip/TripMap'
import {restApi} from "../mixins/RestApiMixin";
import {timeUtils} from '../mixins/TimeUtils'
import {vehicleHelper} from "../mixins/VehicleMixin";
import {mapHelper} from "@/components/mixins/MapMixin";


export default {
    name: "DispatchTrips",
    components: {MapContainer, TripMap},
    mixins: [restApi, timeUtils, vehicleHelper, mapHelper],
    props: {
        dispatch: {
            type: Object,
            required: true
        }
    },
    data: function () {
        return {
            currentPoint: 0,
            currentTime: null,
            currentSpeed: 0,
            isCarSimulating: false,
            mapCenter: null,
            vehicle: null,
            map: null,
            order: null,
            withGeom: false,
            allTrips: false,
            tableItems: [],
            trips: [],
            loading: 0,
            mapItem: null,
            selectMode: 'single',
            areaGroup: null,
            orderGeometry: null,
            fields: [
                {
                    start_time: {
                        label: this.$t('trip_list.start_time'),
                        sortable: true
                    }
                },
                {
                    end_time: {
                        label: this.$t('trip_list.end_time'),
                        sortable: true
                    }
                },
                {
                    mode: {
                        label: this.$t('trip_list.mode'),
                        sortable: true
                    }
                },
                {
                    duration: {
                        label: this.$t('trip_list.duration') + ' (min)',
                        sortable: true
                    }
                },
                {
                    trip_length: {
                        label: this.$t('trip_list.trip_length'),
                        sortable: true
                    }
                },
                {
                    road_coverage: {
                        label: this.$t('daily_summary.road_distance'),
                        sortable: true
                    }
                },
                {
                    delivery: {
                        label: this.$t('contract_reports.unload_records.delivery_id'),
                        sortable: true
                    }
                },
                {
                    tripnote: {
                        label: this.$t('daily_summary.trip_notes'),
                        sortable: false
                    }
                }
            ]
        }
    },
    methods: {

        initMap() {
            if (this.map) {
                this.$nextTick(() => {
                    if(this.getMapSettingsIn(['center'])){
                        let center = this.getMapSettingsIn(['center'])
                        if (center) {
                            this.mapCenter = {
                                y: center.lat,
                                x: center.lng
                            }
                        }
                    }
                    this.map.resizeMap()
                    this.fetchAreaGroup()
                    this.fetchOrderGeometry()
                    this.fetchTrips()
                })
            }
        },

        mapClicked: function (coord) {
            if (this.measureDistanceEnabled) {
                this.addMeasureDistance(coord)
            }

            if (this.measureRoadEnabled) {
                this.$refs.measureRoad.addMeasurePoint(coord)
            }
        },
        fetchAreaGroup: function() {
            // TODO - Fetch areas for contract
        },
        handleAreaGroupResponse: function (response) {
            this.loading--
            if (response) {
                this.areaGroup = response.data
            }
        },
        initTableItems: function () {
            this.tableItems = []
            if (this.trips.length > 0) {
                this.trips.forEach(function (item) {
                    this.tableItems.push({
                        start_time: this.toLocalTime(item.start_time),
                        end_time: this.toLocalTime(item.end_time),
                        duration: this.getDurationInMinutes(item.start_time, item.end_time),
                        mode:  this.getTripModeString(item.mode),
                        trip_length: item.length.toFixed(2),
                        road_coverage: item.road_coverage ? (item.road_coverage/1000).toFixed(2) : '-',
                        id: item.id,
                        delivery: item.delivery_amount ? item.delivery_amount + ' ' + item.delivery_unit : '-',
                        tripnotes: item.tripnotes
                    })
                }, this)
            }
        },
        close: function () {
            this.$refs.tripMap.resetMap()
            this.$emit('close')
        },
        simulateTrip: function () {
            this.$refs.tripMap.showMovingCar()
        },
        setCurrentPoint: function (currentPoint) {
            this.currentPoint = currentPoint
            // Check if mapItem and relevant arrays are available
            if (this.mapItem && this.mapItem.timestamps && this.mapItem.timestamps.length > 0 && this.mapItem.geometry && this.mapItem.geometry.length > 0) {
                // Get current timestamp and geometry
                let currentTime = this.mapItem.timestamps[this.currentPoint];
                this.currentTime = currentTime.substring(11, 16)
                let currentGeometry = this.mapItem.geometry[this.currentPoint];

                // Check if there are consecutive points available
                if (this.currentPoint < this.mapItem.timestamps.length - 1) {
                    // Get next timestamp and geometry
                    let nextTime = this.mapItem.timestamps[this.currentPoint + 1];
                    let nextGeometry = this.mapItem.geometry[this.currentPoint + 1];

                    // Calculate speed between current and next points
                    let speed = this.calculateSpeed(
                        currentGeometry.x, currentGeometry.y,
                        nextGeometry.x, nextGeometry.y,
                        currentTime, nextTime
                    );
                    if(speed !== Infinity) {
                        this.currentSpeed = speed.toFixed(2)
                    }
                }
            }
        },
        setCarPositionSimulating(isCarPositionSimulating) {
            this.isCarSimulating = isCarPositionSimulating
        },
        fetchTrips: function () {
            let params = {}
            this.trips = []
            this.tableItems = []
            if(this.dispatch) {
                params.order = this.dispatch.work_order ? this.dispatch.work_order.id : undefined
                params.customer = this.dispatch.customer_id
                params.contractor = this.dispatch.contractor_id
                params.contract = this.dispatch.contract_id
                //params.area_group = this.dispatch.area_id && this.dispatch.report_tracking_mode === 1 ? this.dispatch.area_id : undefined // Use area only if tracking is limited inside area(s)
                params.with_geom = 1
                params.road_coverage = 0
                params.trip_notes = 1
                params.from = new Date(this.dispatch.created).toISOString()
                params.to = this.dispatch.completed ?
                    new Date(this.dispatch.completed).toISOString() :
                    new Date().toISOString()
                params.timestamps = 1
                params.speed = 1
                this.loading++
                this.restFetchParams(this.tripUrl, params, this.handleResponseTrips, this.handleError)
            }
        },
        handleResponseTrips: function (response) {
            this.loading--
            this.trips = response.data
            this.initTableItems()
        },
        showTripOnMap: function (selectedItems) {
            let item = selectedItems && selectedItems.length > 0 ? selectedItems[0] : null
            if (!item) {
                this.mapItem = null;
                this.$refs.tripMap.resetMap()
                this.showAllTrips()
            } else if (!this.mapItem || this.mapItem.id != item.id) {
                this.allTrips = false
                this.mapItem = null
                if (this.$refs.tripMap) {
                    this.$refs.tripMap.resetMap()
                }
                let trip = this.trips.find(trip => trip.id === item.id)
                if (trip.geometry.length > 1) {
                    this.withGeom = true
                    this.mapItem = trip
                } else {
                    this.withGeom = false
                }
            }
        },

        showAllTrips: function () {
            this.loading++
            this.$refs.selectableTable.clearSelected()
            this.mapItem = null
            this.allTrips = true
            this.loading--
        },

        mapChanged(map) {
            this.map = map
            this.initMap()
        },

        fetchOrderGeometry: function () {
            if (this.dispatch.work_order && this.dispatch.work_order.id) {
                this.loading++
                this.restFetch(this.orderUrl+'/'+this.dispatch.work_order.id+'/geometry',this.handleOrderGeometry)
            }
        },

        handleOrderGeometry: function (response) {
            this.loading--
            if (response && response.data) {
                this.orderGeometry = response.data.length > 0 ? response.data : null
                if (this.orderGeometry && this.orderGeometry.length > 0) {
                    this.map.resizeMap()
                    this.addGeoJsonMapObjects()
                }
            }
        },

        addGeoJsonMapObjects() {
            this.orderGeometry.forEach((item) => {
                if(item.visibility) {
                    this.map.addGeoJsonObjects(JSON.stringify(item.geometry), false, item.color, item.add_polyline_ends,
                        item.transparency ? item.transparency : 1, item.line_width ? item.line_width : 3)
                }
            })
        }

    }
}
</script>
<style>

.map-trip-details-table {
    white-space: nowrap;
    background: rgba(255, 255, 255, 0.7);
    overflow-x: scroll;
    overflow-y: scroll;
    max-height: 10em;
}

.collapsed > .toggle-opened,
:not(.collapsed) > .toggle-closed {
    display: none;
}

.map-trip-details-info-container {
    background-color: rgba(43, 43, 43, 0.8);
    border: 1px solid #404041;
    min-width: 20em;
    z-index: 2;
    margin: .5em;
    position: relative;
    width: fit-content;
    border-radius: .5em;
}

#contract-trip-toggle {
    background: none;
    border: none;
    color: #FFFFFF;
    box-shadow: none;
}

.summary-text {
    color: #FFFFFF;
    text-shadow: 1px 1px #000000;
    font-size: .9em;
}

.upper-text {
    text-transform: uppercase;
}

.orange-divider {
    border-color: #90b677;
    margin-top: 0;
    margin-bottom: 0;
    margin-left: .1em;
    margin-right: .1em;
}

</style>
